import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "reactstrap";

import arrow from "../assets/kangaroo/arrow-cropped.svg";
import girl from "../assets/kangaroo/page5girl.jpg";
import { useNavigate } from "react-router-dom";
import Button from "../component/button/Button";
import { imageBaseApi } from "../services/imageBaseApi";

const SmartPreparation = ({data}) => {
  console.log(data)
  const router = useNavigate();
  const textRef = useRef(null);
  const [textHeight, setTextHeight] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768); // Bootstrap mobile breakpoint
  };

  handleResize(); // initial check
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);


  useEffect(() => {
    const updateHeight = () => {
      if (textRef.current) {
        setTextHeight(textRef.current.offsetHeight);
      }
    };
    
    // Initial height calculation
    updateHeight();
    
    // Recalculate after a short delay to ensure content is rendered
    setTimeout(updateHeight, 100);
    
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [data]); // Added data dependency

  return (
    <div className="main-container">
      <Container className=" mt-3" >
        <Row className="d-flex g-4 align-items-stretch">
          <Col xs={12} lg={6} className="order-2 order-lg-1 h-auto p-0">
            <div ref={textRef}>
              <h1 className="lh-1 font-level-4 heading-margin">
                {data[0]?.heading}
              </h1>
              <p className="font-level-6 responsive-width paragraph-margin">
              {data[0]?.description}
              </p>
              <div onClick={() => router("/test-preparation")} >
                <Button
                  label={data[0]?.buttonText}
                  width="350.4503px"
                  height="60.8861px"
                  margin=""
                  fontSize={22}
                  textColor={data[0]?.buttonColor}
                  fontWeight="800"
                  fontFamily="Proxima Nova Bold"
                  textAlign="center"
                />
              </div>
            </div>
          </Col>
          <Col xs={12} lg={6} className="order-1 order-lg-2 p-0 d-flex justify-content-end">
            <div
              style={{
                height: textHeight > 0 ? `${textHeight}px` : "500px", // Fallback height instead of auto
                width: "100%",
                overflow: "hidden",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                marginBottom: isMobile ? "0.8rem" : "0",
                // marginBottom: "clamp(1rem,5vw,4.2rem)"
              }}
              className="rounded-5"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.3)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <img
                src={imageBaseApi+data[0]?.media?.url}
                alt="Student preparing for test"
                className="rounded-5"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex:0
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SmartPreparation;